<template>
  <f7-row class="wd-100">
    <f7-col width="40">
      <f7-link class="wd-100 h-130 m-t-0 no-ripple" @click="$emit('galeria')">
        <div class="wd-100 h-130" :style="`background-image: url('//madai.mx/assets/images/${storage.carrito[idx].image}'); background-position: center; background-repeat: no-repeat; background-size: cover;`" />
      </f7-link>
      <f7-button href="/aretes/" outline small>Ver Otros</f7-button>
    </f7-col>
    <f7-col width="60">
      <img src="assets/img/otros/check.png" alt="" width="24" style="position: absolute; right: 15px; top: 10px;">
      <span class="d-block text-uppercase bold text-dark">{{ storage.carrito[idx].cve }}</span>
      <span class="favorite-icon">
        <f7-link @click="eliminarCarrito()">
          <f7-icon class="favorite-color" md="material:delete_forever"></f7-icon>
        </f7-link>
      </span>
      <span class="d-block text-uppercase fs-10 bold">
        Aretes
      </span>
      <div class="m-t-5">
        <template v-if="promo.tipo">
          <span class="strike fs-12">
            {{ $helper.str.formatearMoneda(storage.carrito[idx].price) }}
          </span>
          <f7-badge class="d-inline text-uppercase bold h-20 float-right" color="white" style="color: #41ad49; border: 1px solid #41ad49">
            <template v-if="promo.tipo === '3x2'">
              Promoción 3 x 2
            </template>
            <template v-else-if="promo.tipo === '2x1/2'">
              Promoción 2 x 1/2
            </template>
            <template v-else-if="promo.tipo === 'porcentaje'">
              {{ promo.porcentaje }}% de Descuento
            </template>
          </f7-badge>
        </template>
        <div class="bold text-color-madai m-r-10">
          <template v-if="promo.tipo">
            {{ $helper.str.formatearMoneda(promo.price) }}
          </template>
          <template v-else>
            {{ $helper.str.formatearMoneda(storage.carrito[idx].price) }}
          </template>
          <span class="fs-10 p-t-20">IVA INCLUIDO</span>
        </div>
      </div>
      <hr>
      <f7-row>
        <span class="m-t-10 fs-13 text-black" style="font-weight: 500;">* MEDIDA ÚNICA</span>
      </f7-row>
    </f7-col>
  </f7-row>
</template>

<script>
export default {
  props: ['idx', 'promocion'],
  computed: {
    promo () {
      let itm = this.storage.carrito[this.idx]
      return this.promocion.find(item => itm.cve === item.cve) || {}
    }
  },
  methods: {
    eliminarCarrito () {
      let itm = this.storage.carrito[this.idx]
      this.storage.carrito = this.storage.carrito.filter(item => item.cve !== itm.cve)
      this.$emit('validar')
    }
  }
}
</script>
